import { render } from "./Questionario.vue?vue&type=template&id=4cb2ca0c"
import script from "@/assets/js/questionario.js?vue&type=script&lang=js"
export * from "@/assets/js/questionario.js?vue&type=script&lang=js"

import "./Questionario.vue?vue&type=style&index=0&id=4cb2ca0c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__